
















import { Component, Vue } from 'vue-property-decorator'
import { AppFooter, AppMenu } from '@/layout'

@Component({
  components: {
    AppMenu,
    AppFooter
  }
})
export default class App extends Vue {
  get headerImage(): string | undefined {
    return this.$route.meta.headerImage
  }

  get headerText(): string | undefined {
    return this.$route.meta.header
  }
}
